require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-mattersburg-drassburg.json") })
        }
      }, "path---betreuungseinrichtungen-mattersburg-drassburg");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-mattersburg-drassburg!./.cache/json/betreuungseinrichtungen-mattersburg-drassburg.json
// module id = 926
// module chunks = 231608221292675